import { TextArea, TextBox } from "devextreme-react";
import SelectBox from "../../../../common/CustomSelectBox";
import DateBox from "../../../../common/CustomDateBox";
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors"
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import CheckBox from 'devextreme-react/check-box';
import dayjs from "dayjs";
import { factoryProcessClaimsTemplateTypes } from "../../../../../Constantes/documentataionRequestTypes";
import { selectWorkshopSearchResults } from "../../../../../redux/workshopSearch/selectors";
import { CodeTemplates, FactoryProcessCodeTemplates, FactoryProcessTemplates } from "../../../../../Constantes/codeDocumentationTemplates";

function ClaimsRequestForm(props){
    const { classes, onChange, dataForm, template } = props;
    const dispatch = useDispatch();
    const types = useSelector(selectTaxonomyTemplates);
    const typesLoading = useSelector(selectTaxonomyTemplatesLoading)
    const [type, setType] = useState(dataForm?.templateCode)
    const subTypes = [{name: "DRIVER´S", code: "factory_process_maintenance_claim"}, {name: "DRIVEON", code: "factory_process_maintenance_claim_driveon"}]
    const workshopSearchResults = useSelector(selectWorkshopSearchResults)

    useEffect(()=>{
        dispatch(getTaxonomyTemplates({query: "?templateCode=" + template.code}))
    },[template])

    useEffect(()=>{
        if(type && types.length > 0){
        onChange("templateId", getTemplateIdFromCode(type))
        }
    },[type, types])

    function changeDate(field, date){
        let stringDate = null; 
        if(date){
        stringDate = dayjs(date).format()
        }
        onChange(field,stringDate)
    }

    function setPhoneNumber(e){
        let nonDigitsRegExp = /\D/gm;
        const filteredNumber = e.value.replace(nonDigitsRegExp, "")
        onChange("phoneNumber", filteredNumber)
    }

    function setNotes(e){
        const filteredText = deleteStrangeCharacters(e.value); 
        onChange("notes", filteredText)
       
    }

    function getTemplateIdFromCode(code){
        const result = types.find(type=> type.code === code)
        if(result){
            return result.id
        }
    }

    function changeUrgent(value){
        onChange("urgent", value)
        if(value){
            onChange("subType", null)
            onChange("driveOn", false)
        }
    }

    function changeDriver(value){
        if(dataForm?.templateCode === FactoryProcessTemplates.FACTORY_PROCESS_MAINTENANCE_CLAIM){
            if(value){
                onChange("urgent", false)
                onChange("subType", "factory_process_maintenance_claim_driveon")
                onChange("driveOn", value)
            } else {
                onChange("subType", null)
                onChange("driveOn", false)
            }
        }
    }

    useEffect(()=>{
        if(dataForm.workshop){
            onChange("workshop", null)
        }    
    },[workshopSearchResults])

    useEffect(()=>{
        if(dataForm?.templateCode !== FactoryProcessTemplates.FACTORY_PROCESS_MAINTENANCE_CLAIM)
        {
            onChange("subType", null)
            onChange("driveOn", false)
        }

    },[dataForm?.templateCode])

    return(
        <div className={classes.containers} id="documentation-request-form">
            <SelectBox label={"Tipología"} disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => { setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} ></SelectBox>
            <div className="grid-two-columns">
                    <TextBox labelMode="floating" label={"Nome"} key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} ></TextBox>
                    <TextBox labelMode="floating" label={"Apellidos"} key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} ></TextBox>
            </div>            
            <div className={"grid-three-columns"}>
                    <TextBox labelMode="floating" label={"Correo electrónico"} key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} ></TextBox>
                    <TextBox labelMode="floating" label={"Móvil"} key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} ></TextBox>               
                    <SelectBox disabled={!workshopSearchResults} placeholder=" " label={"Taller"} key={"workshop"} name="workshop" value={dataForm?.workshop} onValueChanged={(e) => onChange("workshop",e.value)} dataSource={workshopSearchResults} displayExpr={"name"} className={classes.controlers}  />
                <TextBox labelMode="floating" label={"Motivo Inmovil."} key={"immobilizationReason"} name="immobilizationReason" value={dataForm?.immobilizationReason} onValueChanged={(e) => onChange("immobilizationReason",e.value)} className={classes.controlers} ></TextBox>
                <TextBox labelMode="floating" label={"Tiempo Inmov. (días)"} key={"immobilizationTime"} maxLength={9} name="immobilizationTime" value={dataForm?.immobilizationTime} onValueChanged={(e) => onChange("immobilizationTime",e.value)} className={classes.controlers} ></TextBox>
                <DateBox applyButtonText="Aceptar" label={"Entrada taller"} cancelButtonText="Cancelar" key={"workshopEntry"} name="workshopEntry" type="date" value={dataForm?.workshopEntry} onValueChanged={(e) => changeDate("workshopEntry", e.value)} className={classes.controlers} ></DateBox> 
            </div>
            <div className={"grid-two-columns"}>
                    <div className="template-checkbox-container">
                        <CheckBox key={"urgent"} name="urgent" value={dataForm?.urgent?dataForm?.urgent:false} onValueChanged={(e) => changeUrgent(e.value)}></CheckBox>
                        <label>Urgente usuário taller</label>
                    </div>
            { type === factoryProcessClaimsTemplateTypes.FACTORY_PROCESS_MAINTENANCE_CLAIM && 
                    <div className="template-checkbox-container">
                        <CheckBox key={"subtype"} name="driveon" value={dataForm?.driveOn?dataForm?.driveOn:false} onValueChanged={(e) => changeDriver(e.value)}></CheckBox>
                        <label>DRIVEON</label>
                    </div>
            }
            </div>       
                <TextArea label={"Notas"} labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
        </div>
    )
}

export { ClaimsRequestForm };